import { render, staticRenderFns } from "./SummaryDepotList.vue?vue&type=template&id=b7caf0b4&scoped=true&"
import script from "./SummaryDepotList.vue?vue&type=script&lang=ts&"
export * from "./SummaryDepotList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7caf0b4",
  null
  
)

export default component.exports